<ul class="nav nav-pills nav-fill">
    <li class="nav-item">
        <a class="nav-link" [class.active]="tabIndex==1" href="javascript:void(0);" (click)="setTabIndex(1)">Goal</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="tabIndex==2" href="javascript:void(0);" (click)="setTabIndex(2)">Focus Areas and Action Plan</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="tabIndex==3" href="javascript:void(0);" (click)="setTabIndex(3)">Mid-Year Update</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="tabIndex==4" href="javascript:void(0);" (click)="setTabIndex(4)">End-Year Update</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="tabIndex==5" href="javascript:void(0);" (click)="setTabIndex(5)">Rubric</a>
    </li>
</ul>